import {Chart, IChartProps} from '../chart';
import {IProgressProps, Progress} from '../progress';
import {Button, IButtonProps} from '../button';
import {Grid, GridColumn} from '../grid';
import {CardContent} from '../card';
import {DataInfo} from '../data-info';
import React from 'react';
import {Dropdown} from '../dropdown';
import {TDashboardExpanded} from '../../templates/dashboard/dashboard';
import {isMobileDevice} from '../helpers';
import {handleScreenshotCapture} from '../screenshotbutton/screenshot';

export interface ITemplateOverviewCardProps extends ITemplateOverviewCardHeaderProps {
    chart: IChartProps;
    notEnoughDataText?: string;
}

export interface ITemplateOverviewCardHeaderProps {
    title: string;
    bars?: IProgressProps[];
    actions?: IButtonProps[];
    more?: IButtonProps;
    isExpanded?: boolean;
    setExpanded?: (expanded: boolean) => void;
    name?: TDashboardExpanded;
}

const DashboardOverviewCard: (overview: ITemplateOverviewCardProps) => JSX.Element = (overview: ITemplateOverviewCardProps) => {
    const renderActions: (actions: IButtonProps[]) => JSX.Element = (actions: IButtonProps[]) => {
        if (actions.length === 1) {
            return <Button {...actions[0]} color="white" icon="info" style="link"/>;
        }

        return (
            <Dropdown
                placement="bottom"
                triggerType="click"
            >
                <div className="text">
                    {actions.map((action: IButtonProps, i: number) => (
                        <div key={'history-action-' + i}>
                            <Button {...action} style="link"/>
                        </div>
                    ))}
                </div>
            </Dropdown>
        );
    };

    const getCardHeader = (headerProps: ITemplateOverviewCardHeaderProps): JSX.Element => (
        <Grid noWrap={['sm']} align={['middle-xs']}>
            <GridColumn width={['xs-6', 'max-sm']}>
                <h3>{headerProps.title}</h3>
            </GridColumn>
            {(headerProps.bars || headerProps.actions || headerProps.more || headerProps.setExpanded) &&
            <GridColumn width={['xs-6', 'min-sm']}>
                <Grid align={['middle-xs']} justify={['end-xs']} wrap={['xs']}>
                    {overview.bars && overview.bars.map((bar: IProgressProps, i: number) => (
                        <GridColumn width={['min-xs', 'lg']} key={'history-bar' + i}>
                            <Progress {...bar} />
                        </GridColumn>
                    ))}
                    {headerProps.actions &&
                    <GridColumn width={['xs']}>
                        {renderActions(headerProps.actions)}
                    </GridColumn>
                    }
                    {headerProps.setExpanded &&
                    <GridColumn width={['xs']}>
                        {!isMobileDevice() && (
                            <Button
                                icon={'print'}
                                className={'button__noFill'}
                                color={'white'}
                                onClick={() => handleScreenshotCapture(headerProps.name ?? undefined)}
                            />
                        )}
                        <Button
                            {...headerProps.more}
                            text=""
                            color="white"
                            icon={headerProps.isExpanded ? 'collapse' : 'expand'}
                            onClick={(event: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>): void => {
                                event.preventDefault();

                                if (headerProps.setExpanded) {
                                    headerProps.setExpanded(!headerProps.isExpanded);
                                }

                                if (headerProps.more && headerProps.more.onClick) {
                                    headerProps.more.onClick(event);
                                }
                            }}
                            style="link"
                        />
                    </GridColumn>
                    }
                </Grid>
            </GridColumn>
            }
        </Grid>
    );

    return (
        <CardContent>
            <div className="text">
                {getCardHeader(overview)}
                { overview.notEnoughDataText ? <DataInfo type='info' text={ overview.notEnoughDataText }/> : (<Chart {...overview.chart} hideDots={true}/>) }
            </div>
        </CardContent>
    );
};

export default DashboardOverviewCard;
